import React from 'react';
import { configureStore } from '@reduxjs/toolkit';
import { render as rtlRender } from '@testing-library/react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import configureMockStore from 'redux-mock-store';

import { i18n } from 'src/shared/settings';
import { rootReducer } from 'src/store/configureStore';

// Redux Toolkit 2.x includes thunk middleware by default
const mockStore = configureMockStore();

export class testUtils {
	static renderComponentWithStore = (
		ui: any,
		{
			// @ts-ignore
			preloadedState = undefined as RootState,
			store = configureStore({ reducer: rootReducer, preloadedState }),
			...renderOptions
		} = {}
	) => {
		const Wrapper = ({ children }: { children: React.ReactNode }) => (
			<Provider store={store}>
				<I18nextProvider i18n={i18n}>
					<BrowserRouter>{children}</BrowserRouter>
				</I18nextProvider>
			</Provider>
		);

		return rtlRender(ui, { wrapper: Wrapper, ...renderOptions });
	};

	// create a silly store that can never be changed
	static createMockStore = (storeData: any) => {
		// FIXME: const store: Store<RootState, AnyAction> = mockStore(storeData); -> generate error type
		const store = mockStore(storeData);
		return store;
	};
}
